import { render } from "./BgyxDbTableView.vue?vue&type=template&id=435009f6"
import script from "./BgyxDbTableView.vue?vue&type=script&lang=js"
export * from "./BgyxDbTableView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__